import {Module} from "@intuitionrobotics/ts-common";
import {QueryParam_Email} from "@app/ir-q-app-common/types/auth";
import {QueryParam_JWT} from "@intuitionrobotics/user-account/shared/api";
import {PushPubSubModule} from "@intuitionrobotics/push-pub-sub/app-frontend/modules/PushPubSubModule";
import {AccountModule, LoggedStatus, OnLoginStatusUpdated} from "@intuitionrobotics/user-account/frontend";

type Config = {
    envName: string
    kasperoFeUrl: string
    /** When true, the app serves committed fixtures instead of contacting any
     *  backend / Firebase (offline-first local dev). Set in config-local.ts. */
    offline?: boolean
}

export class EnvironmentModule_Class
    extends Module<Config> implements OnLoginStatusUpdated {
    onLoginStatusUpdated = () => {
        // Push (FCM) needs real Firebase + a backend register endpoint, neither of
        // which exists offline — skip it so offline doesn't spam SW registration / 500s.
        if (this.isOffline())
            return;
        if (AccountModule.getLoggedStatus() === LoggedStatus.LOGGED_IN)
            PushPubSubModule.initApp();
    };

    getKasperoFeUrl() {
        return this.config.kasperoFeUrl;
    }

    getOriginUrl() {
        return window.location.origin;
    }

    getQuery() {
        let query = window.location.search;
        if (query.startsWith("?"))
            query = query.substring(1);
        return query;
    }

    getPathname() {
        return window.location.pathname
    }

    getOrigin = () => {
        const jwtParam = `${QueryParam_JWT}=${QueryParam_JWT.toUpperCase()}`;
        const userEmailParam = `${QueryParam_Email}=${QueryParam_Email.toUpperCase()}`;
        return `${this.getOriginUrl()}${this.getPathname()}?${jwtParam}&${userEmailParam}&${this.getQuery()}`;
    };

    getEnvName() {
        return this.config.envName.toUpperCase();
    }

    isOffline() {
        return !!this.config.offline;
    }

    isProd() {
        return this.getEnvName() === 'PROD';
    }

    isStaging() {
        return this.getEnvName() === 'STAGING';
    }
}

export const EnvironmentModule = new EnvironmentModule_Class("EnvironmentModule");
